import { Alert, Container, Text, Title } from '@mantine/core'

export default function DemoAlert() {
  return (
    <Alert color="yellow">
      <Container size="xl">
        <Title order={5} color="yellow">
          Ambiente de Demonstração
        </Title>
        <Text>Você está atualmente no modo de demonstração.</Text>
      </Container>
    </Alert>
  )
}
